import React, { useEffect, useState } from "react";
import {
    Container,
    Row,
    Col,
    Image,
    Form,
    Button,
    Spinner,
} from "react-bootstrap";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import config from "../../config";
import { toast } from "react-toastify";

const Checkout = () => {
    const navigate = useNavigate();

    const location = useLocation();
    const { course_id, course_name, course_schedule_id, course_fee, course_qty } =
        location.state || {}; // Destructure state

    const courseFee = parseFloat(course_fee) || 1;
    const courseQty = parseInt(course_qty) || 1;

    const total_fee = courseFee * courseQty;
    const gst = total_fee * 0.18;
    const total_with_gst = total_fee + gst;

    // Contact form all field
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [email, setEmail] = useState("");
    const [phonenumber, setPhonenumber] = useState("");

    const [isSubmittingCheckOut, setIsSubmittingCheckOut] = useState(false);

    const [errors, setErrors] = useState({});

    // All Validations
    const validate = () => {
        const newErrors = {};

        if (!firstname) {
            newErrors.firstname = "First Name is required";
        }

        if (!lastname) {
            newErrors.lastname = "Last Name is required";
        }

        if (!email) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = "Email address is invalid";
        }

        if (!phonenumber) {
            newErrors.phonenumber = "Phone Number is required";
        }

        return newErrors;
    };

    useEffect(() => {
        document.title = `Checkout | Agile Seekers`;
        document.getElementById("bodywrap").className = "checkoutmain";
    }, []);

    const checkout_submit = async () => {
        const validationErrors = validate();

        if (Object.keys(validationErrors).length === 0) {

            const options = {
                key: "rzp_live_5Q4YFOP9yZfXVy", // Add your key
                key_secret: "eWvAqDBWwQDRKIIpoyNG2Tll", // Add your key secret
                amount: parseInt(total_with_gst) * 100, // Amount in paise
                currency: "INR",
                name: "Agile Seekers",
                description: "for testing purpose",
                handler: async function (response) {
                    const paymentId = response.razorpay_payment_id;
                    setIsSubmittingCheckOut(true); // Start the loading state
                    let item = {
                        course_id: course_id,
                        course_schedule_id: course_schedule_id,
                        fee: courseFee,
                        number_of_course: courseQty,
                        gst_total: gst,
                        sub_total: total_fee,
                        total_fee: total_with_gst,
                        transaction_id: paymentId,
                        first_name: firstname,
                        last_name: lastname,
                        email: email,
                        phone_number: phonenumber,
                    };

                    try {
                        let response = await fetch(`${config.API_BASE_URL}/booking`, {
                            method: "POST",
                            body: JSON.stringify(item),
                            headers: {
                                "Content-Type": "application/json",
                            },
                        });
                        response = await response.json();

                        if (response.status === 1) {
                            setErrors({});
                            setFirstname("");
                            setLastname("");
                            setEmail("");
                            setPhonenumber("");

                            // Display alert with message
                            toast.success(response.message);

                            // Redirect to /thankyou page
                            navigate("/thankyou", window.scrollTo(0, 0));
                        } else {
                            setIsSubmittingCheckOut(false); // End the loading state
                            toast.error(response.message);
                        }
                    } catch (error) {
                        console.error("Error:", error);
                        toast.error("An error occurred while processing your request.");
                    } finally {
                        setIsSubmittingCheckOut(false); // End the loading state
                    }
                },
                theme: {
                    color: "#07a291db",
                },
                modal: {
                    ondismiss: function () {
                        console.log("Payment failed or cancelled");
                        // Optionally handle any other failure actions here
                    },
                },
            };

            var pay = new window.Razorpay(options);
            pay.open();
            setIsSubmittingCheckOut(false); // Start the loading state
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <>
            <Navbar />

            <section className="checkout-banner">
                <Container fluid>
                    <Row>
                        <Col className="px-0 contimg">
                            <h2>Checkout</h2>
                            <Image
                                src={`${config.BASE_URL}/assets/images/contact.jpg`}
                                className="img-fluid"
                                alt="contimg"
                            />
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="checkout-form">
                <Container>
                    <Row className="justify-content-md-center">
                        <Col md={6} className="check-left">
                            <Col>
                                <h3 className="text-center">Checkout</h3>
                                <Form>
                                    <Row className="mb-3">
                                        <Form.Group as={Col} controlId="fname">
                                            <Form.Label>First Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter First Name"
                                                value={firstname}
                                                onChange={(e) => setFirstname(e.target.value)}
                                            />

                                            {/* First name validation */}
                                            {errors.firstname && (
                                                <div className="text-danger">{errors.firstname}</div>
                                            )}
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="lname">
                                            <Form.Label>Last Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter Last Name"
                                                value={lastname}
                                                onChange={(e) => setLastname(e.target.value)}
                                            />

                                            {/* Last name validation */}
                                            {errors.lastname && (
                                                <div className="text-danger">{errors.lastname}</div>
                                            )}
                                        </Form.Group>
                                    </Row>

                                    <Row className="mb-3">
                                        <Form.Group as={Col} controlId="email">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                placeholder="Enter Email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />

                                            {/* email validation */}
                                            {errors.email && (
                                                <div className="text-danger">{errors.email}</div>
                                            )}
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="phone">
                                            <Form.Label>Phone Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter Phone Number"
                                                value={phonenumber}
                                                onChange={(e) => setPhonenumber(e.target.value)}
                                            />

                                            {/* phonenumber validation */}
                                            {errors.phonenumber && (
                                                <div className="text-danger">{errors.phonenumber}</div>
                                            )}
                                        </Form.Group>
                                    </Row>

                                    <Row className="mb-3">
                                        <Form.Group controlId="course_name">
                                            <Form.Label>Course Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={course_name}
                                                readOnly
                                                disabled
                                            />
                                        </Form.Group>
                                    </Row>

                                    <Row className="mb-3">
                                        <Form.Group as={Col} controlId="course_name">
                                            <Form.Label>Course Price</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={courseFee}
                                                readOnly
                                                disabled
                                            />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="course_name">
                                            <Form.Label>Number of Course</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={courseQty}
                                                readOnly
                                                disabled
                                            />
                                        </Form.Group>
                                    </Row>

                                    <Row className="mb-3">
                                        <Form.Group as={Col} controlId="course_name">
                                            <Form.Label>Sub Total Price</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={total_fee}
                                                readOnly
                                                disabled
                                            />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="course_name">
                                            <Form.Label>GST Applicable 18%</Form.Label>
                                            <Form.Control type="text" value={gst} readOnly disabled />
                                        </Form.Group>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Group controlId="total_price">
                                            <Form.Label>Total Price</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={total_with_gst}
                                                readOnly
                                                disabled
                                            />
                                        </Form.Group>
                                    </Row>
                                    <Button
                                        variant="primary"
                                        type="button"
                                        onClick={checkout_submit}
                                        disabled={isSubmittingCheckOut}
                                    >
                                        {isSubmittingCheckOut ? (
                                            <>
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                    className="mx-2"
                                                />
                                                Loading...
                                            </>
                                        ) : (
                                            "Submit"
                                        )}
                                    </Button>
                                </Form>
                            </Col>
                        </Col>
                    </Row>
                </Container>
            </section>

            <Footer />
        </>
    );
};
export default Checkout;
